var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2022 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useState, useEffect, useContext, useMemo } from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Link as RouterLink } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { PageLimit, DropFile, BreadCrumbSteps, Icon, IconButton, theme, Dialog, } from "@sequentech/ui-essentials";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { EBallotCiphertextCheck, EBallotEncoding, checkAuditableBallotCiphertext, } from "../services/ballotCiphertextVerification";
import TextField from "@mui/material/TextField";
import { faCircleQuestion, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import JsonImg from "../public/json.png";
import Image from "mui-image";
import { TenantEventContext } from "..";
import { GET_BALLOT_STYLES } from "../queries/GetBallotStyles";
import { useAppDispatch } from "../store/hooks";
import { updateBallotStyleAndSelection } from "../services/BallotStyles";
var ActionsContainer = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    margin-bottom: 20px;\n    margin-top: 10px;\n    gap: 2px;\n"], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    margin-bottom: 20px;\n    margin-top: 10px;\n    gap: 2px;\n"])));
var StyledTitle = styled(Typography)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-top: 25.5px;\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n"], ["\n    margin-top: 25.5px;\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n"])));
var StyledButton = styled(Button)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display flex;\n    padding: 5px;\n\n    span {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        padding: 5px;\n    }\n"], ["\n    display flex;\n    padding: 5px;\n\n    span {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        padding: 5px;\n    }\n"])));
var StyledImage = styled(Image)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    max-height: 64px;\n    max-width: 64px;\n"], ["\n    max-height: 64px;\n    max-width: 64px;\n"])));
var FileWrapper = styled(Box)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    align-items: center;\n"], ["\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    align-items: center;\n"])));
var SampleFileName = "sample.json";
var JsonFile = function (_a) {
    var name = _a.name;
    var t = useTranslation().t;
    return (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ variant: "body2", sx: { textAlign: "center", lineHeight: "36px", color: theme.palette.customGrey.main } }, { children: t("homeScreen.fileUploaded") })), _jsxs(FileWrapper, { children: [_jsx(StyledImage, { src: JsonImg, duration: 100, width: "unset" }), _jsx(Typography, __assign({ variant: "body2", sx: { color: theme.palette.black } }, { children: name || SampleFileName }))] })] }));
};
var parseAuditableBallotFile = function (file, ballotService) { return __awaiter(void 0, void 0, void 0, function () {
    var auditableBallotString, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, file.text()];
            case 1:
                auditableBallotString = _a.sent();
                return [2 /*return*/, auditableBallotString];
            case 2:
                e_1 = _a.sent();
                console.log(e_1);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var HomeScreen = function (_a) {
    var confirmationBallot = _a.confirmationBallot, setConfirmationBallot = _a.setConfirmationBallot, ballotId = _a.ballotId, setBallotId = _a.setBallotId, fileName = _a.fileName, setFileName = _a.setFileName, ballotService = _a.ballotService;
    var t = useTranslation().t;
    var _b = useState(false), showError = _b[0], setShowError = _b[1];
    var _c = useState(false), showCiphertextError = _c[0], setShowCiphertextError = _c[1];
    var _d = useState(false), openStep1Help = _d[0], setOpenStep1Help = _d[1];
    var _e = useState(false), openStep2Help = _e[0], setOpenStep2Help = _e[1];
    var _f = useState(false), isNextActive = _f[0], setNextActive = _f[1];
    var navigate = useNavigate();
    var _g = useContext(TenantEventContext), tenantId = _g.tenantId, eventId = _g.eventId;
    var dataBallotStyles = useQuery(GET_BALLOT_STYLES).data;
    var dispatch = useAppDispatch();
    useEffect(function () {
        var newIsNextActive = !!confirmationBallot && !!ballotId;
        if (newIsNextActive !== isNextActive) {
            setNextActive(newIsNextActive);
        }
    }, [confirmationBallot, ballotId, isNextActive]);
    useMemo(function () {
        if (dataBallotStyles && dataBallotStyles.sequent_backend_ballot_style.length > 0) {
            updateBallotStyleAndSelection(dataBallotStyles, dispatch);
        }
    }, [dataBallotStyles]);
    var handleAuditableBallot = function (auditableBallot) {
        var _a;
        var isMultiContest = false;
        var decodedBallot = null;
        try {
            decodedBallot =
                (auditableBallot &&
                    ballotService.decodeAuditableBallot(auditableBallot)) ||
                    null;
        }
        catch (error) {
            var decodedMultiBallot = (!decodedBallot &&
                auditableBallot &&
                ballotService.decodeAuditableMultiBallot(auditableBallot)) ||
                null;
            isMultiContest = true;
            decodedBallot = decodedMultiBallot;
        }
        var ballotStyle = (_a = auditableBallot === null || auditableBallot === void 0 ? void 0 : auditableBallot.config) !== null && _a !== void 0 ? _a : null;
        if (null === auditableBallot || null === decodedBallot || null === ballotStyle) {
            setShowError(true);
            setShowCiphertextError(false);
            setConfirmationBallot(null);
            return;
        }
        // Decoding only reads the plaintext. The ballot is not verified until the
        // plaintext and randomness are shown to reproduce the ciphertext.
        var encoding = isMultiContest
            ? EBallotEncoding.MULTI_CONTEST
            : EBallotEncoding.SINGLE_CONTEST;
        var ciphertextCheck = checkAuditableBallotCiphertext(ballotService, auditableBallot, encoding);
        if (EBallotCiphertextCheck.VERIFIED !== ciphertextCheck) {
            // Only a ciphertext that fails to reproduce is a failed
            // verification. A ballot that could not be checked at all is a
            // problem with the file, and reports the generic import error.
            var isMismatch = EBallotCiphertextCheck.MISMATCH === ciphertextCheck;
            setShowError(!isMismatch);
            setShowCiphertextError(isMismatch);
            setConfirmationBallot(null);
            return;
        }
        var ballotHash = isMultiContest
            ? ballotService.hashMultiBallot(auditableBallot)
            : ballotService.hashBallot512(auditableBallot);
        setConfirmationBallot({
            ballot_hash: ballotHash,
            election_config: ballotStyle,
            decoded_questions: decodedBallot,
        });
        setShowError(false);
        setShowCiphertextError(false);
    };
    var handleFiles = function (files) { return __awaiter(void 0, void 0, void 0, function () {
        var auditableBallotString, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    setFileName(files[0].name);
                    return [4 /*yield*/, parseAuditableBallotFile(files[0], ballotService)];
                case 1:
                    auditableBallotString = _a.sent();
                    auditableBallotString && handleAuditableBallot(JSON.parse(auditableBallotString));
                    return [3 /*break*/, 3];
                case 2:
                    e_2 = _a.sent();
                    setShowError(true);
                    setShowCiphertextError(false);
                    setConfirmationBallot(null);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    // use sample ballot
    var onUseSampleClick = function () {
        setFileName(SampleFileName);
        var auditableBallot = ballotService.generateSampleAuditableBallot();
        if (!auditableBallot) {
            return;
        }
        handleAuditableBallot(auditableBallot);
        var ballotHash = ballotService.hashBallot512(auditableBallot);
        setBallotId(ballotHash);
    };
    var onInputChange = function (e) {
        return setBallotId(e.target.value);
    };
    return (_jsxs(PageLimit, __assign({ maxWidth: "md", className: "home-screen screen" }, { children: [_jsx(Box, __assign({ marginTop: "48px" }, { children: _jsx(BreadCrumbSteps, { labels: [
                        "breadcrumbSteps.import",
                        "breadcrumbSteps.verify",
                        //"breadcrumbSteps.finish",
                    ], selected: 0 }) })), _jsxs(StyledTitle, __assign({ variant: "h5" }, { children: [_jsx("span", { children: t("homeScreen.step1") }), _jsx(IconButton, { icon: faCircleQuestion, sx: { fontSize: "unset", lineHeight: "unset", paddingBottom: "2px" }, fontSize: "16px", onClick: function () { return setOpenStep1Help(true); } }), _jsx(Dialog, __assign({ handleClose: function () { return setOpenStep1Help(false); }, open: openStep1Help, title: t("homeScreen.importBallotHelpDialog.title"), ok: t("homeScreen.importBallotHelpDialog.ok"), variant: "info" }, { children: _jsx("p", { children: t("homeScreen.importBallotHelpDialog.content") }) }))] })), _jsx(Typography, __assign({ variant: "body2", sx: { color: theme.palette.customGrey.main } }, { children: t("homeScreen.description1") })), _jsxs(Alert, __assign({ severity: "error", style: { display: showError ? undefined : "none" }, "data-testid": "import-error" }, { children: [_jsx(AlertTitle, { children: t("homeScreen.importErrorTitle") }), _jsx(Typography, __assign({ variant: "body2" }, { children: t("homeScreen.importErrorDescription") })), _jsx(RouterLink, __assign({ to: "//sequentech.github.io/documentation/docs/general/reference/ballot-encoding", target: "_blank", rel: "nofollow" }, { children: t("homeScreen.importErrorMoreInfo") }))] })), _jsxs(Alert, __assign({ severity: "error", style: { display: showCiphertextError ? undefined : "none" }, "data-testid": "ciphertext-error" }, { children: [_jsx(AlertTitle, { children: t("homeScreen.ciphertextErrorTitle") }), _jsx(Typography, __assign({ variant: "body2" }, { children: t("homeScreen.ciphertextErrorDescription") }))] })), _jsx(DropFile, { handleFiles: handleFiles }), confirmationBallot ? _jsx(JsonFile, { name: fileName }) : null, _jsxs(StyledTitle, __assign({ variant: "h5" }, { children: [_jsx("span", { children: t("homeScreen.step2") }), _jsx(IconButton, { icon: faCircleQuestion, sx: { fontSize: "unset", lineHeight: "unset", paddingBottom: "2px" }, fontSize: "16px", onClick: function () { return setOpenStep2Help(true); } }), _jsx(Dialog, __assign({ handleClose: function () { return setOpenStep2Help(false); }, open: openStep2Help, title: t("homeScreen.ballotIdHelpDialog.title"), ok: t("homeScreen.ballotIdHelpDialog.ok"), variant: "info" }, { children: _jsx("p", { children: t("homeScreen.ballotIdHelpDialog.content") }) }))] })), _jsx(Typography, __assign({ variant: "body2", sx: { color: theme.palette.customGrey.main, marginBottom: 0 } }, { children: t("homeScreen.description2") })), _jsx(Box, __assign({ maxWidth: "630px" }, { children: _jsx(TextField, { label: t("homeScreen.ballotIdLabel"), placeholder: t("homeScreen.ballotIdPlaceholder"), InputLabelProps: { shrink: true }, value: ballotId, onChange: onInputChange }) })), _jsxs(ActionsContainer, { children: [_jsx(StyledButton, __assign({ sx: { width: { xs: "100%", sm: "200px" } }, onClick: onUseSampleClick }, { children: _jsx("span", { children: t("homeScreen.useSampleLink") }) })), _jsxs(StyledButton, __assign({ sx: { width: { xs: "100%", sm: "200px" } }, disabled: !isNextActive, onClick: function () {
                            return isNextActive &&
                                navigate("/tenant/".concat(tenantId, "/event/").concat(eventId, "/confirmation"));
                        } }, { children: [_jsx("span", { children: t("homeScreen.nextButton") }), _jsx(Icon, { icon: faAngleRight, size: "sm" })] }))] })] })));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
